import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { routing } from './email-marketing.routing';

import { EmailMarketingComponent } from './email-marketing.component';
import { EmailMarketingService } from './email-marketing.service';
import { OptionSendComponent } from './option-send/option-send.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { MaterialComponentsModule } from '../../materials.module';
import { ImportCsvComponent } from './import-csv/import-csv.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';

@NgModule({
  declarations: [
    EmailMarketingComponent,
    OptionSendComponent,
    ImportCsvComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialComponentsModule,
    NgxPaginationModule,
    SharedModule,
    routing,
    AutoCompleteModule,
    CalendarModule,
  ],
  providers: [EmailMarketingService],
})
export class EmailMarketingModule {}
